var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionGlobalShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c4.838 0 8.873 3.436 9.8 8h-2.052A8.018 8.018 0 0 0 15 4.582V5a2 2 0 0 1-2 2h-2v2a1 1 0 0 1-1 1H8v2h2v5.732A2 2 0 0 1 9 16v-1l-4.797-4.797A8.003 8.003 0 0 0 10 19.748V21.8c-4.564-.927-8-4.962-8-9.8C2 6.477 6.477 2 12 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18c2.5 0 5 1 5 2.5V22H12v-1.5c0-1.5 2.5-2.5 5-2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionGlobalShare);
export default __webpack_public_path__ + "static/media/ic_action_global_share.a040322bf1cc09a899bb32e536a42f1a.svg";
export { ForwardRef as ReactComponent };